import { useRouter } from 'next/router';
import { z } from 'zod';

export type VoucherCode = z.infer<typeof VoucherCode>;
export const VoucherCode = z.string();

export function useVoucherCode(): VoucherCode | undefined {
  const router = useRouter();
  const voucherCodeParsed = VoucherCode.safeParse(router.query['voucher']);

  return voucherCodeParsed.success ? voucherCodeParsed.data : undefined;
}
